import React from "react";
import "./loading.scss";

const Loading: React.FC = () => {
  return (
    <div className="loading-container">
      <div className="loading-container__loader"></div>
    </div>
  );
};

export default Loading;
